import type { LinkedinCookies } from '@shared/schemas';
import { all, call, getContext, put, select, takeLatest } from 'redux-saga/effects';

import type { LinkedinCookiesGateway } from '../infrastructure/linkedin-cookies.gateway';
import { loadRequested, saveRequested } from './linkedin-cookies.actions';
import { selectJsessionId, selectLiAt } from './linkedin-cookies.selectors';
import { linkedinCookiesActions } from './linkedin-cookies.slice';

/** WORKER: load the current user's cookies on mount. */
function* loadWorker() {
  const gateway: LinkedinCookiesGateway = yield getContext('linkedinCookiesGateway');
  yield put(linkedinCookiesActions.loadStarted());
  try {
    const cookies = (yield call(gateway.load)) as LinkedinCookies;
    yield put(linkedinCookiesActions.loaded(cookies));
  } catch {
    yield put(linkedinCookiesActions.loadFailed());
  }
}

/** WORKER: persist the current draft cookies (read from state). */
function* saveWorker() {
  const gateway: LinkedinCookiesGateway = yield getContext('linkedinCookiesGateway');
  const li_at = (yield select(selectLiAt)) as string;
  const jsession_id = (yield select(selectJsessionId)) as string;
  yield put(linkedinCookiesActions.saveStarted());
  try {
    const cookies = (yield call(gateway.save, { li_at, jsession_id })) as LinkedinCookies;
    yield put(linkedinCookiesActions.saveSucceeded(cookies.cookies_updated_at));
  } catch {
    yield put(linkedinCookiesActions.saveFailed());
  }
}

/** WATCHERS. */
export function* linkedinCookiesSaga() {
  yield all([
    takeLatest(loadRequested.type, loadWorker),
    takeLatest(saveRequested.type, saveWorker),
  ]);
}
